const zodiacOptions = [
    { value: 'aries', label: 'Aries' },
    { value: 'taurus', label: 'Taurus' },
    { value: 'gemini', label: 'Gemini' },
    { value: 'cancer', label: 'Cancer' },
    { value: 'leo', label: 'Leo' },
    { value: 'virgo', label: 'Virgo' },
    { value: 'libra', label: 'Libra'},
    { value: 'scorpio', label: 'Scorpio' },
    { value: 'sagittarius', label: 'Sagittarius' },
    { value: 'capricorn', label: 'Capricorn' },
    { value: 'aquarius', label: 'Aquarius' },
    { value: 'pisces', label: 'Pisces' }
  ]

  const genderOptions = [
    { value: 'female', label: "Female" },
    { value: 'male', label: "Male" },
    { value: 'transgender', label: "Transgender" }
  ]

  const bodyTypeOptions = [
    { value: 'thin', label: 'Thin' },
    { value: 'curvy', label: 'Curvy' },
    { value: 'petite', label: 'Petite'},
    { value: 'athletic', label: 'Athletic' },
    { value: 'extra', label: 'A Little Extra' }
  ]

  const eyeColorOptions = [
    { value: 'amber', label: 'Amber' },
    { value: 'black', label: 'Black' },
    { value: 'blue', label: 'Blue' },
    { value: 'brown', label: 'Brown' },
    { value: 'gray', label: 'Gray' },
    { value: 'green', label: 'Green' },
    { value: 'hazel', label: 'Hazel' },
    { value: 'mixed', label: 'Mixed' }
  ]

  const hairColorOptions = [
    { value: 'black', label: 'Black' },
    { value: 'blonde', label: 'Blonde' },
    { value: 'dark blonde', label: 'Dark Blonde' },
    { value: 'platinum blonde', label: 'Platinum Blonde' },
    { value: 'brunette', label: 'Brunette' },
    { value: 'dark brown', label: 'Dark Brown' },
    { value: 'red', label: 'Red' },
    { value: 'auburn', label: 'Auburn' },
    { value: 'blue', label: 'Blue' },
    { value: 'green', label: 'Green' },
    { value: 'gray', label: 'Gray' },
    { value: 'pink', label: 'Pink' },
    { value: 'purple', label: 'Purple' },
    { value: 'orange', label: 'Orange' },
    { value: 'salt and pepper', label: 'Salt and Pepper' },
    { value: 'many', label: 'Many' },
    { value: 'bald', label: 'Bald' }
  ]

  const heightOptions = [
    {
      "value": "4'0",
      "label": "4'0"
    },
    {
      "value": "4'1",
      "label": "4'1"
    },
    {
      "value": "4'2",
      "label": "4'2"
    },
    {
      "value": "4'3",
      "label": "4'3"
    },
    {
      "value": "4'4",
      "label": "4'4"
    },
    {
      "value": "4'5",
      "label": "4'5"
    },
    {
      "value": "4'6",
      "label": "4'6"
    },
    {
      "value": "4'7",
      "label": "4'7"
    },
    {
      "value": "4'8",
      "label": "4'8"
    },
    {
      "value": "4'9",
      "label": "4'9"
    },
    {
      "value": "4'10",
      "label": "4'10"
    },
    {
      "value": "4'11",
      "label": "4'11"
    },
    {
      "value": "5'0",
      "label": "5'0"
    },
    {
      "value": "5'1",
      "label": "5'1"
    },
    {
      "value": "5'2",
      "label": "5'2"
    },
    {
      "value": "5'3",
      "label": "5'3"
    },
    {
      "value": "5'4",
      "label": "5'4"
    },
    {
      "value": "5'5",
      "label": "5'5"
    },
    {
      "value": "5'6",
      "label": "5'6"
    },
    {
      "value": "5'7",
      "label": "5'7"
    },
    {
      "value": "5'8",
      "label": "5'8"
    },
    {
      "value": "5'9",
      "label": "5'9"
    },
    {
      "value": "5'10",
      "label": "5'10"
    },
    {
      "value": "5'11",
      "label": "5'11"
    },
    {
      "value": "6'0",
      "label": "6'0"
    },
    {
      "value": "6'1",
      "label": "6'1"
    },
    {
      "value": "6'2",
      "label": "6'2"
    },
    {
      "value": "6'3",
      "label": "6'3"
    },
    {
      "value": "6'4",
      "label": "6'4"
    },
    {
      "value": "6'5",
      "label": "6'5"
    },
    {
      "value": "6'6",
      "label": "6'6"
    },
    {
      "value": "6'8",
      "label": "6'8"
    },
    {
      "value": "6'9",
      "label": "6'9"
    },
    {
      "value": "6'10",
      "label": "6'10"
    },
    {
      "value": "6'11",
      "label": "6'11"
    },
    {
      "value": "7'0",
      "label": "7'0"
    },
    {
      "value": "7'0+",
      "label": "7'0+"
    }
  ]
  const experienceOptions = [
    { value: 'yes', label: 'Yes, I have experience' },
    { value: 'no', label: 'No, I do not have experience' }
  ]


export {
  genderOptions,
  zodiacOptions,
  bodyTypeOptions,
  eyeColorOptions,
  hairColorOptions,
  heightOptions,
  experienceOptions,
}